


const GoogleMap = () => {
    return (
        <div className="map-area">
            <div className="maps">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.8771243885153!2d101.6404761757093!3d3.127173053285805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc498f5a296c0b%3A0x13a06d3a38c0d422!2sEd-Mun%20Academy!5e0!3m2!1sen!2smy!4v1708339430109!5m2!1sen!2smy"></iframe>
            </div>
        </div>
    );
}
 
export default GoogleMap;